/* The Measured Bowl — entradas con scroll y matriz de condiciones.
   Idempotente y compatible con el editor de Shopify, que re-renderiza
   secciones sin recargar la página. */
(function () {
  if (window.__mbInit) return;
  window.__mbInit = true;

  /* ---------- entradas con scroll ---------- */
  function initReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.mb-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('mb-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-mb-delay') || '0', 10);
        setTimeout(function () { el.classList.add('mb-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) {
      if (el.dataset.mbInit) return;
      el.dataset.mbInit = '1';
      io.observe(el);
    });
  }

  /* ---------- matriz de condiciones ---------- */
  function initMatrix(root) {
    var scope = root || document;
    var boxes = scope.querySelectorAll('[data-mb-matrix]');

    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.mbMatrixInit) return;
      box.dataset.mbMatrixInit = '1';

      var btns = box.querySelectorAll('[data-mb-cond]');
      var panes = box.querySelectorAll('[data-mb-pane]');
      if (!btns.length) return;

      function select(key) {
        Array.prototype.forEach.call(btns, function (b) {
          var on = b.getAttribute('data-mb-cond') === key;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.setAttribute('tabindex', on ? '0' : '-1');
        });
        Array.prototype.forEach.call(panes, function (p) {
          p.hidden = p.getAttribute('data-mb-pane') !== key;
        });
      }

      Array.prototype.forEach.call(btns, function (b, i) {
        b.addEventListener('click', function () {
          select(b.getAttribute('data-mb-cond'));
        });
        b.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = btns[(i + 1) % btns.length];
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = btns[(i - 1 + btns.length) % btns.length];
          if (!next) return;
          e.preventDefault();
          next.focus();
          select(next.getAttribute('data-mb-cond'));
        });
      });

      select(btns[0].getAttribute('data-mb-cond'));
    });
  }

  function boot(root) {
    initReveal(root || document);
    initMatrix(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();
